// Modules
import Common from "./modules/common";

// Autoload modules
const modules = [Common];

modules.forEach((module) => {
  module.init();
});

// import local dependencies
import Router from "./utils/Router";

import templateHome from "./partials/home";
import templateBlog from "./partials/blog";
import templateContacts from "./partials/contacts";
import singlePost from "./partials/single";
import taxProductCategory from "./partials/product-cat";

// Populate Router instance with DOM routes
const routes = new Router({
  templateHome,
  templateBlog,
  templateContacts,
  templateApplication: templateContacts,
  singlePost,
  taxProductCategory
});

// Load Events
$(document).ready(() => routes.loadEvents());
